import { AxiosResponse } from 'axios';
import api from './api';

function path(endPath: string = ''): string {
    return `/kosa${endPath}`;
}

export class KosaService {
    static async get(id: string): Promise<AxiosResponse> {
        return api.get(path(`/${id}`));
    }

    static async allByNode(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/all/${nodeId}`));
    }

    static async byDevice(deviceId: number): Promise<AxiosResponse> {
        return api.get(path(`/device/${deviceId}`));
    }
}
